/* Proper PDP lightbox on top of Dawn's product-modal:
 * one media at a time, prev/next arrows, counter, keyboard nav,
 * opens on the media the shopper clicked. */
(() => {
  const modal = document.querySelector('product-modal');
  if (!modal) return;
  const content = modal.querySelector('.product-media-modal__content');
  if (!content) return;
  const medias = [...content.querySelectorAll('[data-media-id]')];
  if (medias.length === 0) return;

  let idx = 0;

  const nav = document.createElement('div');
  nav.className = 'vitae-lb-nav';
  nav.innerHTML = `
    <button type="button" class="vitae-lb-btn" data-lb-prev aria-label="Previous image">&larr;</button>
    <span class="vitae-lb-counter" data-lb-counter></span>
    <button type="button" class="vitae-lb-btn" data-lb-next aria-label="Next image">&rarr;</button>`;
  modal.appendChild(nav);
  if (medias.length === 1) nav.hidden = true;

  const counter = nav.querySelector('[data-lb-counter]');

  function show(i) {
    idx = (i + medias.length) % medias.length;
    medias.forEach((m, j) => m.classList.toggle('vitae-lb-hidden', j !== idx));
    counter.textContent = `${idx + 1} / ${medias.length}`;
    const active = medias[idx];
    const playable = active.querySelector('video');
    medias.forEach((m) => m.querySelectorAll('video').forEach((v) => v.pause()));
    if (playable) playable.play().catch(() => {});
  }

  nav.querySelector('[data-lb-prev]').addEventListener('click', (e) => { e.stopPropagation(); show(idx - 1); });
  nav.querySelector('[data-lb-next]').addEventListener('click', (e) => { e.stopPropagation(); show(idx + 1); });

  document.addEventListener('keydown', (e) => {
    if (!modal.hasAttribute('open')) return;
    if (e.key === 'ArrowLeft') show(idx - 1);
    if (e.key === 'ArrowRight') show(idx + 1);
  });

  /* Hover-to-magnify: the zoom follows the cursor across the image */
  medias.forEach((m) => {
    const img = m.tagName === 'IMG' ? m : m.querySelector('img');
    if (!img) return;
    img.addEventListener('mousemove', (e) => {
      const r = img.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    });
  });

  /* When Dawn opens the modal it marks the clicked media active;
     start the lightbox there */
  new MutationObserver(() => {
    if (!modal.hasAttribute('open')) return;
    const active = content.querySelector('.active[data-media-id]') || medias[0];
    show(medias.indexOf(active));
  }).observe(modal, { attributes: true, attributeFilter: ['open'] });
})();
